import * as React from 'react'
import styled from '@emotion/styled'
import { transparentize } from 'polished'
import { Link } from '@material-ui/core'
import { heights, dimensions, colors, fonts, widths, breakpoints } from '../styles/variables'
import Container from './Container'
import { getEmSize } from '../styles/mixins'

const StyledFooter = styled.div`
  height: ${heights.footer}px;
  padding: 0 ${dimensions.containerPadding}rem;
  background-color: ${colors.brand};
  color: ${transparentize(0.5, colors.white)};
  width: 100%;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    height: 500px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`

const FooterInner = styled(Container)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding-left: 60px;
  padding-right: 60px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    flex-direction: column;
    padding-left: 20px;
    padding-right: 20px;
    justify-content: space-around;
  }
`
const LeftFooter = styled.div``
const RightFooter = styled.div`
  display: flex;
  flex-direction: column;
`
const MiddleFooter = styled.div`
  border: 1px solid ${colors.darkBlue};
  padding: 11px;
`

const StyledP = styled.p`
  margin: 0;
`
const StyledLink = styled(Link)`
  margin: 0;
`

const Footer = () => {
  return (
    <StyledFooter>
      <FooterInner>
        <LeftFooter>
          <StyledP>Justin Jones for Congress</StyledP>
          <StyledP>4610 Charlotte Ave, Suite 2020</StyledP>
          <StyledP>Nashville, TN 37209</StyledP>
        </LeftFooter>
        <MiddleFooter>
          <StyledP>Paid for by Justin Jones for Congress</StyledP>
        </MiddleFooter>
        <RightFooter>
          <StyledLink href="mailto:info@justinjones2020.com">info@justinjones2020.com</StyledLink>
          <StyledLink href="mailto:press@justinjones2020.com">press@justinjones2020.com</StyledLink>
          <StyledLink href="https://twitter.com/brotherjones_">@brotherjones_</StyledLink>
        </RightFooter>
      </FooterInner>
    </StyledFooter>
  )
}

export default Footer
